import { useTranslation } from 'react-i18next';

export default function Quote() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language || 'kk';

  const isEn = lang.startsWith('en');
  const isRu = lang.startsWith('ru');

  return (
    <section className="relative bg-background-950 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20Kazakh%20East%20Asian%20Mongoloid%20young%20men%20athletes%20team%20with%20broad%20cheekbones%20almond%20eyes%20short%20black%20hair%20in%20matching%20military%20sports%20uniforms%20standing%20in%20disciplined%20formation%20at%20dusk%20outdoor%20Kazakhstan%20steppe%20ground%20silhouettes%20against%20dramatic%20amber%20red%20sunset%20sky%20dust%20and%20haze%20in%20air%20near-black%20foreground%20warm%20golden%20backlight%20muted%20earth%20tones%20olive%20and%20sand%20premium%20cinematic%20sports%20photography%20no%20text%20no%20flags%20no%20western%20caucasian%20faces&width=1920&height=800&seq=quote-kz-v4&orientation=landscape&nocache=true"
          alt="Federation Team"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-background-950/80" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 py-20 md:py-28 lg:py-36">
        <div className="max-w-4xl mx-auto text-center">
          {/* Quote mark */}
          <div className="mb-6 md:mb-8">
            <span className="font-heading text-6xl md:text-8xl text-accent-500/30 leading-none">«</span>
          </div>

          {/* Quote text */}
          <blockquote className="font-heading text-xl sm:text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground-50 uppercase tracking-wide leading-tight mb-8 md:mb-10">
            {isEn
              ? 'Here strength, character, and honor are born.'
              : isRu
              ? 'Здесь рождается сила, характер и честь.'
              : 'Мұнда күш, мінез бен абырой туады.'}
            <br />
            <span className="text-accent-500">
              {isEn
                ? 'Military-applied sports are the path to mastery, responsibility, and service to the Motherland.'
                : isRu
                ? 'Военно-прикладные виды спорта — путь к мастерству, ответственности и служению Родине.'
                : 'Әскери-қолданбалы спорт түрлері — шеберлікке, жауапкершілікке және Отанға қызмет етуге апаратын жол.'}
            </span>
          </blockquote>

          {/* Divider */}
          <div className="flex items-center justify-center gap-4 mb-6 md:mb-8">
            <div className="w-12 h-px bg-accent-500/40" />
            <div className="w-2 h-2 bg-accent-500 rotate-45" />
            <div className="w-12 h-px bg-accent-500/40" />
          </div>

          {/* Author */}
          <div className="text-center">
            <p className="font-heading text-sm md:text-base text-foreground-300 uppercase tracking-widest">
              — Болат Байжан
            </p>
            <p className="mt-1 text-xs text-foreground-600 tracking-wider uppercase">
              {isEn ? 'Head of Federation' : isRu ? 'Руководитель Федерации' : 'Федерация басшысы'}
            </p>
          </div>

          {/* Coordinate */}
          <div className="mt-8 coordinate">
            <span>QUOTE.SECTOR.01 // PRIORITY: HIGH</span>
          </div>
        </div>
      </div>

      <div className="h-px bg-gradient-to-r from-transparent via-accent-500/20 to-transparent" />
    </section>
  );
}